module.exports = __webpack_public_path__ + "img/jf3.2728b5be.png";